// Common
import { default as GR } from "./common/GR.webp";

// Live
import { default as DG } from "./live/DG.webp";
import { default as AB } from "./live/AB.webp";
import { default as SA } from "./live/SA.webp";
import { default as WM } from "./live/WM.webp";
import { default as YB } from "./live/YB.webp";

// Slot
import { default as DB } from "./slots/DB.webp";
import { default as RTG } from "./slots/RTG.webp";
import { default as DT } from "./slots/DT.webp";
import { default as BNG } from "./slots/bng.webp";
import { default as RSG } from "./slots/RSG.webp";
import { default as ATG } from "./slots/atg.webp";
import { default as ZG } from "./slots/ZB.webp";

//Board
import { default as GFGD } from "./board/GFGD.webp";

// Sport
import { default as SportSUPER } from "./sport/SUPER.webp";
import { default as SportAlaba } from "./sport/Alaba.webp";
import { default as SportOBSB } from "./sport/OBSB.webp";

// Fishing
import { default as FishSP } from "./fishing/SP.webp";

// Lottery
import { default as LotterySUPER } from "./lottery/logo-SUPER.webp";
import { default as Lottery9K } from "./lottery/logo-9k.webp";


export const ProviderLogo = {
  GR,
  DG,
  AB,
  SA,
  WM,
  YB,
  DB,
  RTG,
  DT,
  BNG,
  RSG,
  ATG,
  ZG,
  GFGD,
  SportSUPER,
  SportAlaba,
  SportOBSB,
  FishSP,
  LotterySUPER,
  Lottery9K,
}